<template>
  <div class="meal-plans-list">
    <span class="meal-plans-list__title" v-if="isMoreThanOneMealPlan">{{
      translate('rdSelectMealPlan')
    }}</span>
    <span class="meal-plans-list__title" v-else>{{ translate('rdMealPlanIncluded') }}</span>

    <div :class="getFlexDirectionStyle()" class="meal-plans-list__inputs">
      <label
        v-for="(meal, index) in meals"
        :key="index"
        class="meal-plans-list__item"
        :class="[
          { 'border border-dark font-weight-bolder': selectedMeal == meal.stayId },
          { 'custom-control': isMoreThanOneMealPlan }
        ]"
      >
        <template v-if="isMoreThanOneMealPlan">
          <input
            class="custom-control-input title"
            @click="onSelectMeal(meal.stayId, meal.code)"
            type="radio"
            :key="index"
            :id="meal.code"
            :value="meal.stayId"
            v-model="selectedMeal"
          />
          <span class="custom-control-indicator radio">
            <span></span>
          </span>
        </template>
        <i :class="meal.classIcon" class="mx-3 sm custom-control-icon" />
        <div class="d-flex d-lg-block meal-container">
          <div class="text-14 mr-3 mr-lg-0">
            <span class="custom-control-description">
              {{ meal.description ? meal.description : null }}
            </span>
          </div>
          <div v-if="meal.price && isMoreThanOneMealPlan && !isMobile">
            <span class="text-12">
              {{ getMealPrice(meal.price) }}
            </span>
          </div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'MealPlansList',
  props: {
    meals: {
      type: Array
    },
    active: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    selectedMeal: ''
  }),
  computed: {
    ...mapGetters(['hotel']),
    isMoreThanOneMealPlan() {
      return this.meals.length > 1
    },
    isMobile() {
      return global.isMobile()
    },
    mealsWithoutBB() {
      return this.meals.filter(meal => meal.code !== 'BB')
    },
    isTierVip() {
      return this.hotel.freeUpgradeBB
    }
  },
  methods: {
    getFlexDirectionStyle() {
      if (this.meals.length === 2) {
        return 'column-direction'
      } else {
        return 'row-direction'
      }
    },
    setDefaultMeal: function () {
      this.selectedMeal = this.active
    },
    getMealPrice(mealPrice) {
      return `(+${mealPrice.currency} ${parseFloat(mealPrice.amount)})`
    },
    onSelectMeal(value, mealCode) {
      this.$emit('selectedMeal', value, mealCode)
    }
  },
  created() {
    this.setDefaultMeal()
  },
  watch: {
    meals: function () {
      this.setDefaultMeal()
      this.$emit('isRoomOnly', this.active.includes('RO'))
    }
  }
}
</script>

<style lang="scss">
.meal-plans-list {
  &__title {
    font-size: 1.6rem;
    font-weight: 700;
  }

  &__inputs {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0.8rem;
    gap: 12px;
    &.column-direction {
      flex-direction: column;
    }
    &.row-direction {
      flex-direction: row;
    }
    @media (min-width: 992px) {
      justify-content: inherit;
    }

    .custom-control {
      &-indicator {
        &.radio {
          inset: 0 auto 0 0;
          margin: auto 8px;
        }
      }
    }
  }

  &__item {
    border: 1px solid #d8d8d8;
    border-radius: 28px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.4rem 2rem;

    @media (min-width: 992px) {
      min-width: 230px;
      max-width: fit-content;
    }
    @media (max-width: 992px) {
      padding: 0.8rem 2rem;
    }
    .meal-container {
      line-height: normal;
    }
  }
}
</style>
